import { useCallback, useState } from 'react'
import { Button, Input, message } from 'antd'
import {useNavigate, useSearchParams} from 'react-router-dom';
import {useUserInfoContext} from '@/store/userInfo'
import * as api from '@/api/user'
import styles from './style.module.less'
import userIcon from '@/assets/images/login-user.png'
import pwdIcon from '@/assets/images/login-pwd.png'

const Account = () => {
  const [userName, setUserName] = useState('')
  const [password, setPassword] = useState('')
  const context = useUserInfoContext()
  const [searchParams] = useSearchParams()
  const navigator = useNavigate()
  const [loading, setLoading] = useState(false)

  const handleLogin = useCallback(async () => {
    setLoading(true)
    const res = await api.login({
      type: 'account',
      userName,
      password
    }).finally(() => {
      setLoading(false)
    })
    if(res.status === 'ok') {
      context.updateUserInfo(res)
      const target = searchParams.get('f') || '/'
      navigator(target, {
        replace: true
      })
    } else {
      message.warning(res.errmsg);
    }
  }, [password, userName, context, navigator, searchParams])

  return (
    <div>
      <div className={`flex align-center radius-3 overflow-hidden ${styles['form-item']}`}>
        <div className={styles['form-item-icon']}>
          <img src={userIcon} alt="" />
        </div>
        <div className='flex-1 w-0 h-full'>
          <Input className='h-full' onChange={(e) => setUserName(e.target.value)} placeholder='用户名' />
        </div>
      </div>
      <div className={`flex align-center radius-3 overflow-hidden ${styles['form-item']}`}>
        <div className={styles['form-item-icon']}>
          <img src={pwdIcon} alt="" />
        </div>
        <div className='flex-1 w-0 h-full'>
          <Input.Password  className='h-full' onChange={(e) => setPassword(e.target.value)} placeholder='密码' />
        </div>
      </div>
      <Button loading={loading} type="primary" block className={styles['login-btn']} onClick={handleLogin}>登&emsp;录</Button>
    </div>
  )
}

export default Account
